import { useState, useEffect } from 'react';
import { ITree, useAsyncEffect } from '@smart/design';
import SensorTagModel from '../models/SensorTagModel';
export default function useSensorTag(companyId: string) {
  const [tags, setTags] = useState<ITree>(null);

  useAsyncEffect(function*(onCancel, c) {
    const tree = yield* c(SensorTagModel.load(companyId));
    setTags(tree);
  }, []);

  return tags;
}
